import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { NgxPaginationModule } from 'ngx-pagination';
import { OnlysuperuserDirective } from '../../../../shared/directives/onlysuperuser.directive';
import { catchError, map, Observable, switchMap, tap } from 'rxjs';
import { PAGINATION } from '../../../../core/constants/constants';
import { Line } from '../../../../core/models/line.interface';
import { LayoutService } from '../../../../core/services/layout/layout';
import { ActivatedRoute, Router } from '@angular/router';
import { Filter, QueryGet } from '../../../../core/types/query-types';
import { LineService } from '../../../../core/services/line/line';
import { LineForm } from '../line-form/line-form';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from '../../../../core/services/loading/loading';
import { PermisionDirective } from '../../../../shared/directives/permision.directive';
import { Title } from '@angular/platform-browser';
import { Search } from "../../../../shared/components/search/search";

@Component({
  selector: 'app-line-list',
  imports: [
    MatIcon,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    NgxPaginationModule,
    AsyncPipe,
    OnlysuperuserDirective,
    PermisionDirective,
    Search
],
  templateUrl: './line-list.html',
  styleUrl: './line-list.scss',
})
export class LineList {
  public page = 1;
  total: number = 0;
  limit: number = 10;
  lines: Line[] = [];
  asyncLines!: Observable<Line[]>;
  buscarline: string = '';
  @Input() filtro: string = '';
  @Input() orden: string = '';
  showColumns: string[] = ['acciones', 'id', 'name', 'description'];

  constructor(
    private layoutService: LayoutService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private lineService: LineService,
    private loadingService: LoadingService,
    private title: Title,
  ) {this.title.setTitle('Líneas');}

  ngOnInit(): void {
    this.layoutService.paginationLimit$
      .pipe(
        switchMap((limit) => {
          this.limit = limit;
          return this.activatedRouter.queryParamMap;
        }),
        switchMap((params) => {
          const pageNum = params.get('page') || '1';
          const search = params.get('search') || '';
          this.page = parseInt(pageNum);
          this.fetchLine(PAGINATION.first_page, null, search);
          return this.layoutService.paginationLimit$;
        }),
      )
      .subscribe();
  }

  fetchLine(page: number, filter: Filter | null = null, search = '') {
    const offset = page > 1 ? page * this.limit - this.limit : 0;
    const params: QueryGet = {
      order: '-id',
      limit: this.limit,
      offset,
      search,
      filters: [],
    };
    if (filter) {
      params.filters.push(filter);
    }
    this.page = page;
    this.loadingService.show(true);
    this.asyncLines = this.lineService.getLine(params).pipe(
      tap((data) => {
        this.lines = data.results;
        this.lineService.setLine(data.results[0]);
        this.lineService.setLines(data.results);
        this.total = data.count;
      }),
      map((res) => {
        this.loadingService.show(false);
        return res.results;
      }),
      catchError((error) => {
        this.loadingService.show(false);
        const errorMsg = `¡Se ha producido un error, inténtelo nuevamente!`;
        this.toastr.error(errorMsg, 'Error!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.router.navigate(['home']);
        return [];
      }),
    );
  }

  createLine() {
    this.lineService.removeLineSelected();
    const dialogRef = this.dialog.open(LineForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchLine(this.page);
    });
  }

  updateLine(line: Line) {
    this.lineService.setLine(line);
    const dialogRef = this.dialog.open(LineForm, {
      width: '600px',
      height: 'auto',
      maxHeight: '80vh',
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.fetchLine(this.page);
    });
  }

  eliminate(line: Line): void {
    const confirmed = window.confirm(`¿Estás seguro de eliminar el registro: ${line.name}?`);
    if (!confirmed) return;
    this.lineService.delete(line.id).subscribe({
      next: () => {
        const successMsg = `Eliminado CORRECTAMENTE!`;
        this.toastr.success(successMsg, 'Exitoso!', {
          progressBar: true,
          timeOut: 5000,
        });
        this.fetchLine(this.page);
      },
      error: (err) => {
        this.toastr.error('No se pudo eliminar', 'Error');
      },
    });
  }
}
